<template>
    <ul class="ed-breadcrumb">
      <slot></slot>
    </ul>
</template>

<script>
  export default {
    name: 'BreadcrumbList',
  };
</script>



// WEBPACK FOOTER //
// breadcrumbList.vue?7edbf8a1